<template>
  <!-- 这个是编辑项目的页面 -->
  <div class="contain">
    <!-- 这里边是标题和返回 -->
    <div class="title_box">
      <h4>添加外籍讲着邀请</h4>
      <el-button size="small" type="info" @click="backProject">返回</el-button>
    </div>
    <el-card class="box-card">
      <!-- 这里边是一个表单 -->
      <el-form
        ref="form"
        :model="form"
        size="small"
        label-width="80px"
        label-position="top"
      >
        <el-form-item label="会议名称" required>
          <el-col :span="11">
            <el-input
              v-model="form.name"
              placeholder="请输入会议名称"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="会议时间" required>
          <el-col :span="20">
            <!-- 这里边是时间 -->
            <el-date-picker
              v-model="value1"
              type="datetime"
              placeholder="选择日期时间"
            >
            </el-date-picker>
            <span style="padding: 0 30px">至</span>
            <el-date-picker
              v-model="value2"
              type="datetime"
              placeholder="选择日期时间"
            >
            </el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item label="会议地点" required>
          <el-col :span="16">
            <el-input
              v-model="form.name"
              placeholder="请输入会议地点"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="会议日程" required>
          <el-col :span="24">
            <div class="checked">
              <div
                class="add"
                v-for="(item, index) in title"
                :key="item"
                @click="changetitle(index)"
                :class="index === actives ? 'active' : ''"
              >
                {{ item }}
              </div>
            </div>
            <div class="box" v-if="actives === 0">
              <div
                class="inputs"
                v-for="(item, index) in form.list"
                :key="item.id"
              >
                <!-- 选择日期时间 -->
                <el-date-picker
                  class="chilren"
                  v-model="item.name"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
                <el-input
                  placeholder="请输入内容"
                  v-model="item.value"
                  class="chilren"
                >
                  <template slot="prepend">议题</template>
                </el-input>
                <el-input
                  placeholder="请输入内容"
                  v-model="item.input"
                  class="chilren"
                >
                  <template slot="prepend">讲者</template>
                </el-input>
                <div class="buttons">
                  <el-button type="primary" size="mini" @click="additems(index)"
                    >+</el-button
                  >
                  <el-button
                    class="sizemini"
                    type="info"
                    size="mini"
                    v-if="index !== 0"
                    @click="removeitem(index)"
                    >-</el-button
                  >
                </div>
              </div>
            </div>
            <div class="uploadimg" v-if="actives === 1">
              <el-upload
                action="https://jsonplaceholder.typicode.com/posts/"
                list-type="picture-card"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
              <span style="color: #cc0808; font-size: 12px"
                >可上传多张日程图</span
              >
            </div>
          </el-col>
        </el-form-item>
        <el-form-item label="会议平台" required>
          <el-col :span="9">
            <el-select v-model="form.value" placeholder="选择平台">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="讲者姓名&机构" required>
          <el-col :span="7">
            <el-input
              v-model="form.name"
              placeholder="请输入讲者姓名&机构"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="会议资料" required>
          <div v-for="(item, index) in form.wenjian" :key="index">
            <el-col :span="10">
              <el-input
                v-model="item.name"
                placeholder="请输入资料名称"
              ></el-input>
            </el-col>
            <el-button
              style="margin-left: 30px"
              type="primary"
              size="small"
              @click="addfile(index)"
              >添加</el-button
            >
            <el-button
              type="info"
              size="small"
              @click="removefile(index)"
              v-if="index !== 0"
              >删除</el-button
            >
            <el-col :span="24">
              <div class="uploads">
                <el-upload
                  class="upload-demo"
                  action="https://jsonplaceholder.typicode.com/posts/"
                  multiple
                  :limit="3"
                >
                  <el-button size="small" type="info">选择文件</el-button>
                </el-upload>
                <span class="ticks"
                  >请上传TXT、DOC、XLS、PPT、DOCX、XLSX、PPTX、PDF
                  等文件格式</span
                >
              </div>
            </el-col>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            style="background: #484c7f"
            @click="onSubmit"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'editorProject',
  data () {
    return {
      options: [],
      dialogImageUrl: '',
      dialogVisible: false,
      title: [
        '添加日程',
        '上传日程'
      ],
      actives: 0,
      form: {
        value: '',
        name: '',
        textarea: '',
        list: [
          { name: '', value: '', input: '' },
        ],
        wenjian: [
          {
            name: '',
            file: ''
          }
        ]
      },

      value1: '',
      value2: '',
    }
  },
  methods: {
    changetitle (index) {
      this.actives = index
    },
    // 点击提交表单
    onSubmit () {
      console.log('submit!')
    },
    backProject () {
      this.$router.push('/')
    },
    // 添加数值
    additems (index) {
      var content = this.form.list[index]
      if (content.name == '' && content.value == '' && content.input === '') {
        this.$message({
          message: '内容为空不能添加',
          type: 'warning'
        });
        return
      }
      this.form.list.splice(index + 1, 0, { name: '', value: '', input: '' })
      console.log(this.form.list)
    },
    removeitem (index) {
      this.form.list.splice(index, 1)

    },
    addfile (index) {
      var content = this.form.wenjian[index]
      if (content.name == '' && content.file == '') {
        this.$message({
          message: '内容为空不能添加',
          type: 'warning'
        });
        return
      }
      this.form.wenjian.splice(index + 1, 0, {
        name: '',
        file: ''
      })
    },
    // 删除项目
    removefile (index) {
      this.form.wenjian.splice(index, 1)
    }
  }
}
</script>

<style lang='less' scoped>
.contain {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  // display: flex;
  // flex-direction: column;
  .title_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 23px;
    h4 {
      font-size: 28px;
      color: #212529;
    }
  }
  .box-card {
    width: 100%;
  }
  .checked {
    width: 162px;
    height: 28px;
    display: flex;
    .add {
      flex: 1;
      height: 100%;
      border: 1px solid #df89e2;
      color: #212529;
      line-height: 28px;
      text-align: center;
      &:nth-child(1) {
        border-radius: 14px 0 0 14px;
      }
      &:nth-child(2) {
        border-radius: 0 14px 14px 0;
      }
    }
    .active {
      background: #df89e2;
      color: #fff;
    }
  }
  .box {
    margin-top: 12px;
  }
  .inputs {
    display: flex;
    margin-top: 20px;
    .chilren {
      flex: 1;
      margin-right: 20px;
    }
  }
  .buttons {
    width: 120px;
  }
  // 这里是上传文件
  .uploads {
    width: 100%;
    display: flex;
    margin-top: 18px;
    margin-bottom: 30px;
    .upload-demo {
      display: flex;
      // align-items: center;
      .el-button {
        border-radius: 6px 0 0 6px;
      }
      /deep/ .el-upload-list {
        border: 1px solid #f0f0f0;
        border-radius: 0 6px 6px 0;
        width: 421px;
        height: 32px;
        margin-top: 1px;
        .el-upload-list__item {
          margin: 3px 0;
        }
      }
    }
    .ticks {
      color: #cc0808;
      font-size: 12px;
      margin-top: 10px;
      margin-left: 13px;
    }
  }
  .uploadimg {
    margin-top: 20px;
  }
}
</style>
